export const getElementId = (entityId: string, fieldPath?: string): string =>
  fieldPath ? `${entityId}_${fieldPath}` : entityId;

export const getElementRect = (elementId: string): DOMRect | undefined =>
  document.getElementById(elementId)?.getBoundingClientRect();
